import axios from "axios";
import { CURRENT_API_URL } from "../../../Utils/Constants";

function FetchAccountHealthReportService(token, data) {

    return axios.post(`${CURRENT_API_URL}/sellerPartner/fetchAccountHealthReport`, data,
            {
                headers: {
                    Authorization: token,
                },
            }
        )
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            console.log(error);
            throw error;
        });
}

export default FetchAccountHealthReportService;
